import type { FC } from 'react';
import React from 'react';

import Blog16Icon from '@atlaskit/icon-object/glyph/blog/16';
import Image16Icon from '@atlaskit/icon-file-type/glyph/image/16';
import AttachmentIcon from '@atlaskit/icon/core/attachment';
import Page16Icon from '@atlaskit/icon-object/glyph/page/16';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';
import DatabaseIcon from '@atlaskit/icon/core/database';
import AiGenerativeSlidesIcon from '@atlaskit/icon-lab/core/ai-generative-slides';
import SmartLinkIcon from '@atlaskit/icon/core/smart-link';

export const SearchResultTypeIcon: FC<{ contentType: string }> = ({ contentType }) => {
	switch (contentType) {
		case 'blogpost':
			return <Blog16Icon label="page icon" />;
		case 'image':
			return <Image16Icon label="page icon" />;
		case 'attachment':
			return <AttachmentIcon label="page icon" spacing="spacious" />;
		case 'whiteboard':
			return <WhiteboardIcon label="whiteboard icon" />;
		case 'database':
			return <DatabaseIcon label="database icon" />;
		case 'slide':
			return <AiGenerativeSlidesIcon label="slide icon" />;
		case 'embed':
			return <SmartLinkIcon label="embed icon" />;
		case 'page':
		case 'comment':
		default:
			return <Page16Icon label="page icon" />;
	}
};
